export default function reducer(state = false, action) {
  switch (action.type) {
    case 'AUTH_LOGGED_IN': {
      return action.payload;
    }
    case 'AUTH_LOGGED_OUT':
    case 'AUTH_LOGIN_FAILED': {
      return null;
    }
    default: return state;
  }
}
